import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=1bfe8ddf&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=1bfe8ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe8ddf",
  null
  
)

export default component.exports